import {getPackages} from "../network/PackageListNetworkAPI";

export const PackageReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {lineHaulId, containerId, filters, dispatcher, packageState} = action.data;
            getPackages(filters, dispatcher, lineHaulId, containerId, packageState)
            return state
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/package/reducer/PackageReducer.js